<span *ngIf="count && count>0" class="d-inline-block text-logo-blue cursor-pointer text-underline lH-12"> 
    {{ count }}
</span>

<span *ngIf="!count"> 
    {{ count }}
</span>